<div class="container py-5">
  <div class="row">

    <div class="col-12 mb-5">
      <div class="row">

        <div class="col-12 col-md-8">
          @if(encuestaCliente?.empresa?.logo) {
            <div class="row d-flex justify-content-center">
              <div class="col-6 col-md-4 col-lg-3 text-center text-md-start">
                <img [src]="encuestaCliente?.empresa!.logo?.url" width="100%">
              </div>
            </div>
          }
        </div>

        <div class="col-12 col-md-4">
          <div class="row">
            <div class="col-12 mb-1">
              <small 
                class="text-secondary fw-300">
                Progreso
              </small>
            </div>
            <div class="col-12">
              @if(encuestaCliente?.progreso != null) {
                <ngb-progressbar 
                  class="mb-3" 
                  type="success" 
                  [value]="encuestaCliente!.progreso">
                  {{ encuestaCliente!.progreso }}%  
                </ngb-progressbar>
              }
            </div>
          </div>
        </div>

      </div>
    </div>
    
    <div class="col-12 mb-3">
      <div class="row">

        @for (pregunta of encuestaCliente?.paso?.preguntas; track $index) {
          <div class="col-12 mb-5">
            <div class="row">

              <app-pregunta-item
                [pregunta]="pregunta">
              </app-pregunta-item>

            </div>
          </div>
        }

      </div>
    </div>

    <div class="col-12 text-end">
      <button 
        class="btn btn-primary"
        [disabled]="isDisabled()"
        (click)="onSubmit()">
        Siguiente
      </button>
    </div>

  </div>
</div>